import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Moon = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="vuesax/outline/moon">
        <g id="moon">
          <path
            id="Vector"
            d="M8.30826 15.1666C8.19493 15.1666 8.08159 15.1666 7.96826 15.16C4.23493 14.9933 1.11493 11.9866 0.854926 8.31995C0.62826 5.17329 2.44826 2.23329 5.38159 0.999954C6.21493 0.653288 6.65493 0.919954 6.84159 1.11329C7.02826 1.29995 7.28826 1.73329 6.94159 2.52662C6.63493 3.23329 6.48159 3.98662 6.48826 4.75995C6.50159 7.71329 8.95493 10.22 11.9483 10.34C12.3816 10.36 12.8083 10.3266 13.2216 10.2533C14.1016 10.0933 14.4683 10.4466 14.6083 10.6733C14.7483 10.9 14.9083 11.3866 14.3749 12.1066C12.9616 14.04 10.7149 15.1666 8.30826 15.1666ZM1.84826 8.24662C2.07493 11.42 4.78159 14.02 8.00826 14.16C10.2016 14.2666 12.2816 13.2666 13.5616 11.52C13.6616 11.38 13.7083 11.28 13.7283 11.2266C13.6683 11.22 13.5616 11.2133 13.3949 11.2466C12.9083 11.3333 12.4016 11.3666 11.9016 11.3466C8.38159 11.2066 5.50159 8.25329 5.48159 4.77329C5.48159 3.85329 5.66159 2.96662 6.02826 2.13329C6.09493 1.98662 6.10826 1.88662 6.11493 1.83329C6.05493 1.83329 5.94826 1.84662 5.77493 1.91995C3.23493 2.98662 1.66159 5.53329 1.84826 8.24662Z"
          />
        </g>
      </g>
    </svg>
  );
};

Moon.displayName = 'Moon';
